import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Optional } from '@honda-canada/design-system-react';
import { HOUR_SEPARATOR } from './utils/constants';
const DealerHours = ({ isDealerOpen, message, isHoursUnavailable, ...rest }) => {
    const { t } = useTranslation();
    const dealerStatus = isDealerOpen ? t('Shared.Common.openLabel') : t('Shared.Common.closedLabel');
    return (_jsxs(Copy, { size: "extraSmall", color: "white", ...rest, children: [_jsxs(Optional, { when: isDealerOpen, children: [_jsx("span", { "data-testid": "cy-dealer-hours-status", children: dealerStatus }), ` ${HOUR_SEPARATOR} `, _jsx("span", { "data-testid": "cy-dealer-hours-message", children: message })] }), _jsx(Optional, { when: isHoursUnavailable, children: _jsx("span", { "data-testid": "cy-dealer-hours-message", children: message }) })] }));
};
export default DealerHours;
